import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ConnectRestService } from 'src/app/services/connect-rest.service';
import { AppUtilityService } from 'src/app/common/app-utility.service';
import { environment, countryCodes } from 'src/environments/environment.prod'; 
import { EnglishTranslation, MalayTranslation } from '../app.constants';
import { DataStoreService } from '../data-store.service';

declare var $: any;
@Component({
  selector: 'app-last-step',
  templateUrl: './last-step.component.html',
  styleUrls: ['./last-step.component.scss']
})
export class LastStepComponent implements OnInit {

  lastStep: FormGroup;
  // private phonePattern = /^((60(\s|-)?))(((?!0)(?![2-9])(?!80)(?!81)\d{1,2})[1]?)(\s|-)?\d{2,4}(\s|-)?\d{4}$/;
  // private phonePattern = /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/;
  // private emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  mobileMaxInput : Number = 48;
  mobileMinInput : Number = 1;
  mobileNumberPattern : any = this.AppUtility.mobileNumberPattern('60');
  CountryCodes = countryCodes;
  contactInfo: string;
  isContactInfo: any = sessionStorage.getItem("contactInfo");

  ConnectedParties: any;
  CompanyDetails: any;
  partyCounts: boolean = false;
 
  ApplicantName: string;
  NRIC: string;
  SecondDirectorName: any
  textContent: any;

  constructor(public router: Router,
    private formBuilder: FormBuilder,
    private connect: ConnectRestService,
    private AppUtility: AppUtilityService,
    private dataStoreService: DataStoreService
  ) {
    //used to prevent back button --- added by Sonny
    sessionStorage.currentPage = window.location.href;
   }

  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue) {
    if (elemValue.target.id === 'applicant_mobile_number') {
      return this.AppUtility.mobileNumberValidation(elemValue.key)
    } else if (elemValue.target.type === 'text' || elemValue.target.type === 'email') {
      return this.AppUtility.characterValidation(elemValue.key)
    }
  }


  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.LastStepScreen : MalayTranslation.LastStepScreen;
    
    var defaultValue = { "ApplicantName": null, "EmailAddress": null, "mobileNumber": null, "countryCode": '60' }   

    this.lastStep = this.formBuilder.group({
      mobileNumber: [defaultValue.mobileNumber, [Validators.required, Validators.pattern(this.mobileNumberPattern)]],
      email: [defaultValue.EmailAddress, [Validators.required, Validators.pattern(environment.emailPatternHTML5)]],
      applicantCountryCode: [defaultValue.countryCode, [Validators.required]]
    });

    this.retrieveData();

    $(document).ready(() => {     

      $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
          return false;
        }
      })

      $("#obaoform").validate({       
        rules: {          
          applicant_mobile_number: {
            required: true,
            number: true
          },
          email_address: {
            required: true
          },
        },
        messages: {  
          applicant_mobile_number: {
            required: this.textContent.numberError.required,
            minlength:  () => { return this.textContent.numberError.minlength1 + this.mobileMinInput + this.textContent.numberError.minlength2 }
          },
          email_address: {
            required: this.textContent.emailError.required ,
            email: this.textContent.emailError.pattern,
            pattern: this.textContent.emailError.pattern
          }
        }, errorPlacement: function (error, element) {
          if (element.attr("name") == "applicant_mobile_number") {
            error.appendTo($("#applicant_mobile_error_container"));
          }
          if (element.attr("name") == "email_address") {
            error.appendTo($("#email_address_error_container"));
          }

        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }

      });


    });

    this.onCountryCodeChange(this.lastStep.value.applicantCountryCode);   
    
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('last-step');
    }
  }

  async retrieveData(){
    var RequestID = "R0200";
    var respData = await this.connect.connectRest('', RequestID, '');
    // console.log(respData);
    this.setData(respData);
  }

  setData(respData){
    this.ApplicantName = respData.ApplicantList[0].Name;
    this.NRIC = respData.ApplicantList[0].DisplayNRIC;
    sessionStorage.setItem("secondDirector", this.ApplicantName);
    sessionStorage.setItem("secondDirectorNRIC", this.NRIC);
  }
  async onSubmit() {
    var RequestID = "S0200";
    var data = {
      "Name": this.ApplicantName,
      "NRIC": this.NRIC,
      "Email": this.lastStep.value.email,
      "ContactNumber": this.lastStep.value.applicantCountryCode + '-' + this.lastStep.value.mobileNumber,
    }
    var respData = await this.connect.connectRest(data, RequestID, '');

    if(respData.Status == "Success"){
      this.router.navigate(['/end-last-step']);
    }
    // if(respData['IsEKYCAvailable'] == "false"){
    //   this.router.navigate(['/one-more-step-without-ekyc']);

    // } else {
    //   this.router.navigate(['/end-last-step']);
    // }
  }

  public async restConnect(data) {    
   
  }

  onCountryCodeChange(elemValue) {
    var respValue = this.AppUtility.mobileNumberMinMaxLength(elemValue)
    this.mobileMaxInput = respValue.max
    this.mobileMinInput = respValue.min

    // Added by CJ for Mobile Number Pattern 14Jul2020
    this.mobileNumberPattern = this.AppUtility.mobileNumberPattern(elemValue);
    this.lastStep.get("mobileNumber").setValidators([Validators.required,Validators.pattern(this.mobileNumberPattern)]);
  }

  resetMobileValidation(){
    if(this.lastStep.controls['mobileNumber'].dirty){
    $('#applicant_mobile_number').valid()
    }
  }

  
  public async updateMethod(data) {
    const RequestID = 'S0016';
    const companyData = await this.connect.connectRest(data, RequestID, '')
    if (companyData.Status === 'Success') {
      this.router.navigate(['/business-detail']);
    }

  
  }


}
